/**
 * クチコミLodge関連のユーティリティ関数
 */

/**
 * 企業詳細ページのURLを生成
 * @param enterpriseId 企業ID
 * @returns クチコミLodgeの企業詳細ページURL
 */
export const getKuchikomiEnterpriseDetailUrl = (
  enterpriseId: string | number
): string => {
  const baseUrl = process.env.REACT_APP_KUCHIKOMI_BASE_URL
  return `${baseUrl}/enterprises/${enterpriseId}`
}

/**
 * クチコミ検索ページのURLを生成
 * @param params 検索パラメータ
 * @returns クチコミLodgeの検索ページURL
 */
export const getKuchikomiSearchUrl = (params: {
  keyword?: string
  sdgsCategory?: string
  corporateCategory?: string
  industry?: string
  region?: string
}): string => {
  const baseUrl = process.env.REACT_APP_KUCHIKOMI_BASE_URL
  const searchParams = new URLSearchParams({
    keyword: params.keyword || '',
    sdgsCategory: params.sdgsCategory || '',
    corporateCategory: params.corporateCategory || '',
    industry: params.industry || '',
    region: params.region || '',
  })
  return `${baseUrl}/search/kuchikomi?${searchParams.toString()}`
}

/**
 * クチコミLodgeの企業詳細ページを新しいタブで開く
 * @param enterpriseId 企業ID
 */
export const openKuchikomiEnterpriseDetail = (
  enterpriseId: string | number
): void => {
  const url = getKuchikomiEnterpriseDetailUrl(enterpriseId)
  window.open(url, '_blank')
}

/**
 * クチコミLodgeの検索ページを新しいタブで開く
 * @param params 検索パラメータ
 */
export const openKuchikomiSearch = (params: {
  keyword?: string
  sdgsCategory?: string
  corporateCategory?: string
  industry?: string
  region?: string
}): void => {
  const url = getKuchikomiSearchUrl(params)
  window.open(url, '_blank')
}
